module.exports = __webpack_public_path__ + "static/media/van500.01bdd822.svg";